import React from 'react';

export const Companies = (props) => {

   return (
      <div className={props.className}>
      </div>
   )

}